import React, {Component} from 'react'
import styles from './style.css'
import DateField from 'App/components/fields/Nebula/DateField'
import autobind from 'autobind-decorator'
import SelectField from 'App/components/fields/Nebula/SelectField'
import withGraphQL from 'react-apollo-decorators/lib/withGraphQL'
import gql from 'graphql-tag'
import PropTypes from 'prop-types'
import Paginated from 'meteor-paginated-graphql-react'
import moment from 'moment'
import formatCurrency from 'App/helpers/formatCurrency'

@withGraphQL(gql`
  query getUserWallets {
    me {
      _id
      country {
        code
        referentialCurrency {
          code
        }
      }
      wallets {
        _id
        currency {
          code
          units
          format
          name
          symbol
          isCrypto
          minimumAmountToSend
          isMaintenance
        }
        transformFactor {
          factor
          outCurrency {
            code
            units
            format
            symbol
          }
        }
      }
    }
  }
`)
export default class Main extends Component {
  static propTypes = {
    me: PropTypes.object
  }

  constructor(props) {
    super(props)
    this.state = {
      datePicker: {startDate: new Date(moment().startOf('month').toString()), endDate: new Date()},
      selectedCurrency: null,
      code: 'USDT'
    }
    this.currencies = []
  }

  componentDidMount() {
    this.parserOptions()
  }

  parserOptions() {
    if (this.props.me && this.props.me.wallets) {
      const currencies = this.props.me.wallets.map(wallet => ({
        value: wallet._id,
        label: wallet.currency.name
      }))
      this.currencies = currencies
    }
  }

  @autobind
  onChangeDate(dates) {
    const [start, end] = dates

    this.setState({
      datePicker: {
        startDate: start,
        endDate: end
      }
    })
  }

  @autobind
  onChangeSelect(value) {
    this.setState({selectedCurrency: value})
  }

  getFields() {
    return [
      {
        title: 'Monto',
        name: 'amount',
        render: ({amount, currency}) => formatCurrency(amount, currency)
      },
      {
        title: 'Comisión',
        name: 'commission',
        render: ({commission, currency}) => formatCurrency(commission, currency)
      },
      {
        title: 'Balance',
        name: 'balance',
        render: ({balance, currency}) => formatCurrency(balance, currency)
      },
      {
        title: 'Tipo',
        name: 'type',
        render: ({type, currency}) => this.renderType(type, currency)
      },
      {
        title: 'Mercado',
        name: 'market.name',
        render: ({market}) => market.name
      },
      {
        title: 'Fecha',
        name: 'date',
        render: ({date}) => moment(date).format('LLL'),
        sort: 'DESC',
        defaultSort: 'DESC'
      }
    ]
  }

  @autobind
  renderType(type, currency) {
    const {isCrypto} = currency
    if (type === 'airdrop') return 'Airdrop'
    if (type === 'devolution') return 'Devolución'
    if (type === 'discount') return 'Descuento'
    if (type === 'trade-in') return 'Trade'
    if (type === 'trade-out') return 'Trade'
    if (type === 'send' && isCrypto) return 'Envío'
    if (type === 'send' && !isCrypto) return 'Retiro'
    if (type === 'recieve' && isCrypto) return 'Entrada externa'
    if (type === 'recieve' && !isCrypto) return 'Abono'
    return type
  }

  render() {
    return (
      <div className={`${styles.main} .col-xs-12`}>
        <div className={`${styles.box} content col`}>
          <div className={styles.header}>
            <h2 className="headline-4 text-title-resting">Historial</h2>
          </div>
          <div className={`${styles.body} col`}>
            <div className={`${styles.filters} row`}>
              <DateField
                label="Rango de fecha"
                startDate={this.state.datePicker.startDate}
                endDate={this.state.datePicker.endDate}
                useLabel
                onChange={this.onChangeDate}></DateField>
              <SelectField
                label="Cryptomoneda"
                onChange={this.onChangeSelect}
                value={this.state.selectedCurrency}
                options={this.currencies}></SelectField>
            </div>
            <div className={`${styles.contentTable} col`}>
              <div className={`${styles.tableSettings} row`}></div>
              <div className={`${styles.table}`}>
                <Paginated
                  queryName="transactions"
                  fields={this.getFields()}
                  walletId={this.state.selectedCurrency ? this.state.selectedCurrency.value : null}
                  initPeriod={this.state.datePicker.startDate}
                  finalPeriod={this.state.datePicker.endDate}
                  extraFields={['currency {units, format}']}
                  params="$walletId: ID, $initPeriod: Date, $finalPeriod: Date"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/History/Main/index.js